import { render, staticRenderFns } from "./user-refund-list.vue?vue&type=template&id=4f578e5d&scoped=true&"
import script from "./user-refund-list.vue?vue&type=script&lang=js&"
export * from "./user-refund-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f578e5d",
  null
  
)

export default component.exports